/**
 * フロントJS
 */

class Front {
    constructor() {
        //グローバルメニューを途中から固定
        $( window ).on( 'scroll', function() {
            if ( 768 < $( this ).scrollTop() ) { // 768px以上スクロールしたら
                $( '#header' ).addClass( 'js-fixed' );
            } else {
                $( '#header' ).removeClass( 'js-fixed' );
            }
        });

        //ハンバーガーメニュー
        $(".btn_open").click(function () {
            $(this).toggleClass("active");
            $(".header_nav").toggleClass("active");
            $("body").toggleClass("active");
        });

        // トップへ戻るボタン
        window.addEventListener('scroll', function() {
            let topBtn = document.querySelector('#page-top');
            const scrollPosition = window.pageYOffset;

            // 100vhの高さを取得
            const viewportHeight = window.innerHeight;

            // スクロール位置が100vhを超えたらボタンを表示
            if (scrollPosition > viewportHeight) {
                topBtn.classList.add('active');
            } else {
                topBtn.classList.remove('active');
            }
        });

        //SPやiPadでホバー時アニメーション無効（ontouchstart）
        var touch = 'ontouchstart' in document.documentElement
        || navigator.maxTouchPoints > 0
        || navigator.msMaxTouchPoints > 0;
        if (touch) { // remove all :hover stylesheets
            try { // prevent exception on browsers not supporting DOM styleSheets properly
                for (var si in document.styleSheets) {
                    var styleSheet = document.styleSheets[si];
                    if (!styleSheet.rules) continue;
                    for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                        if (!styleSheet.rules[ri].selectorText) continue;
                        if (styleSheet.rules[ri].selectorText.match(':hover')) {
                            styleSheet.deleteRule(ri);
                        }
                    }
                }
            } catch (ex) {}
        }          

        //アコーディオン（PC)
        $('.js-accordion-title').on('click', function () {
            $(this).next().slideToggle(200);
            $(this).toggleClass('open', 200);
        });  

        //アコーディオン（SP)
        if (window.matchMedia( "(max-width: 767px)" ).matches) {
            $('.js-accordion-title_sp').on('click', function () {
                $(this).next().slideToggle(200);
                $(this).toggleClass('open', 200);
            });  
        }

        //モーダル
        var scrollPos; // topからのスクロール位置

        $('.modal-btn').click(function() {
            var modalId = $(this).data('modal-id'); // ボタンからモーダルIDを取得
            scrollPos = $(window).scrollTop(); // topからのスクロール位置を取得
            $('.modal').fadeOut(); // すべてのモーダルを非表示にする
            $('.modal[data-modal-id="' + modalId + '"]').fadeIn(); // 対応するモーダルをフェードイン
            $('.modal-main-container').addClass('slide'); // モーダル本体をスライドイン
            $('body').addClass('fixed').css({ top: -scrollPos }); // 背景固定
            return false; // <a>を無効化
        });

        $('.modal-close, .modal-bg').click(function() { // 閉じるまたは背景をクリックしたら
            $('.modal').fadeOut(); // すべてのモーダルをフェードアウト
            $('.modal-main-container').removeClass('slide'); // モーダル本体をスライドアウト
            $('body').removeClass('fixed').css({ top: 0 }); // 背景固定を解除
            $(window).scrollTop(scrollPos); // 元の位置までスクロール
            return false; // <a>を無効化
        });

        $(window).keyup(function(e) { // キーボードのキーを押して
            if (e.key === "Escape") { // ESCキーだったら
                $('.modal').fadeOut(); // すべてのモーダルをフェードアウト
                $('.modal-main-container').removeClass('slide'); // モーダル本体をスライドアウト
                $('body').removeClass('fixed').css({ top: 0 }); // 背景固定を解除
                $(window).scrollTop(scrollPos); // 元の位置までスクロール
            }
        });

        //スマホ版viewport切り替え
        function viewportSet() {
            var wsw = window.screen.width;
            if (wsw <= 374) {
                // デバイス横幅374px以下
                $("meta[name='viewport']").attr("content", "width=374");
            } else {
                // それ以外
                $("meta[name='viewport']").attr("content", "width=device-width");
            }
        }
        viewportSet();
        $(window).on("resize orientationchange", viewportSet);

        //スライダー(MV)
        // if( $('.mv_slider').length > 0 ){
        //     $('.mv_slider').slick({
        //         autoplay: true,
        //         speed: 800,
        //         lazyLoad: 'progressive',
        //         arrows: false,
        //         dots: false,
        //         centerMode: false,
        //     }).slickAnimation();
        // }

        //スライダー(マイぺージ：最近見た求人)
        if( $('.recent_slider').length > 0 ){
            $('.recent_slider').slick({
                autoplay: false,
                speed: 800,
                lazyLoad: 'progressive',
                arrows: false,
                dots: false,
                centerMode: false,
                infinite: false,
                variableWidth: true,
            }).slickAnimation();
        }
    }
}

const front = new Front();